import React from 'react'
import { NavLink } from 'react-router-dom'
import { StoreContext } from '../../store'
import { canManageAccountSessions } from '../../pages/accountSessions/accountSessionsPolicy'

const WrapperLink = ({ to, children }) => <NavLink activeClassName="orangeBtnByPage" to={to}>{children}</NavLink>;

const showTradingStrategies =
  process.env.REACT_APP_SHOW_TRADING_STRATEGIES === '1' || process.env.NODE_ENV !== 'production';

const showMarketAnalysis =
  process.env.REACT_APP_SHOW_MARKET_ANALYSIS === '1' || process.env.NODE_ENV !== 'production';

const showBrokerPortfolio =
  process.env.REACT_APP_SHOW_BROKER_PORTFOLIO === '1' || process.env.NODE_ENV !== 'production';

const DashboardMenu = () => {
 const {store} = React.useContext(StoreContext);
 const showAccountSessions = canManageAccountSessions(store);
 return (
 <div className="row">
   <div className="col-12 col-lg-12 col-xl-12">
     <div className="dashHead">
       <h2>
         <span>Dashboard</span>
       </h2>
       <ul>
         <li>
           <WrapperLink to="/cabinet/stocks">Stocks</WrapperLink>
         </li>
         <li>
           <WrapperLink to="/cabinet/search">Data Search</WrapperLink>
         </li>
         {showMarketAnalysis && (
           <li>
             <WrapperLink to="/cabinet/market-analysis">Market Analysis</WrapperLink>
           </li>
         )}
         {showTradingStrategies && (
           <li>
             <WrapperLink to="/cabinet/strategies">Trading Strategies</WrapperLink>
           </li>
         )}
         {showBrokerPortfolio && (
           <li>
             <WrapperLink to="/cabinet/broker-portfolio">Broker Portfolio</WrapperLink>
           </li>
         )}
         <li>
           <WrapperLink to="/cabinet/orders">Orders</WrapperLink>
         </li>
         <li>
           <WrapperLink to="/cabinet/profile">Profile</WrapperLink>
         </li>
         {showAccountSessions && (
           <li>
             <WrapperLink to="/cabinet/sessions">Sessions</WrapperLink>
           </li>
         )}
       </ul>
     </div>
   </div>
 </div>
 );
};

export default DashboardMenu;
